import { getHttpClient } from './httpClient';

export type LLMProvider = 'openai' | 'anthropic' | 'ollama' | 'groq' | 'together';

export interface PlatformLLMConfig {
  id: string;
  name: string;
  provider: LLMProvider;
  model: string;
  baseUrl: string | null;
  hasApiKey: boolean;
  temperature: number;
  maxTokens: number;
  isActive: boolean;
  sequentialMode: boolean;
  updatedAt: string;
}

export interface PlatformLLMConfigInput {
  name?: string;
  provider?: LLMProvider;
  model?: string;
  baseUrl?: string | null;
  apiKey?: string | null;
  temperature?: number;
  maxTokens?: number;
  isActive?: boolean;
  sequentialMode?: boolean;
}

export async function getPlatformLLMConfig(): Promise<PlatformLLMConfig | null> {
  const { data } = await getHttpClient().get<{ ok: boolean; config: PlatformLLMConfig | null }>(
    '/api/admin/platform-llm-config',
  );
  return data.config;
}

export async function updatePlatformLLMConfig(
  payload: PlatformLLMConfigInput,
): Promise<PlatformLLMConfig> {
  const { data } = await getHttpClient().put<{ ok: boolean; config: PlatformLLMConfig }>(
    '/api/admin/platform-llm-config',
    payload,
  );
  return data.config;
}

export interface TestResult {
  success: boolean;
  message: string;
  latencyMs: number;
}

export interface TestInput {
  provider: LLMProvider;
  model: string;
  baseUrl?: string | null;
  apiKey?: string | null;
}

export async function testPlatformLLMConfig(payload: TestInput): Promise<TestResult> {
  const { data } = await getHttpClient().post<{
    ok: boolean;
    success: boolean;
    message: string;
    latencyMs: number;
  }>('/api/admin/platform-llm-config/test', payload);
  return {
    success: data.success,
    message: data.message,
    latencyMs: data.latencyMs,
  };
}
